import { render, staticRenderFns } from "./BtnLoader.vue?vue&type=template&id=7a6e4305&"
import script from "./BtnLoader.vue?vue&type=script&lang=ts&"
export * from "./BtnLoader.vue?vue&type=script&lang=ts&"
import style0 from "./BtnLoader.vue?vue&type=style&index=0&id=7a6e4305&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports